import { ConvexReactClient } from "convex/react"
import { CONVEX_URL } from "./config"

if (!CONVEX_URL) {
  console.warn("VITE_CONVEX_URL is not set — Convex queries will fail. Add it to apps/web/.env.local")
}

// Fall back to a syntactically-valid placeholder so a misconfigured env degrades
// to "queries never resolve" instead of crashing the whole app at module load.
export const convex = new ConvexReactClient(CONVEX_URL || "https://placeholder.convex.cloud")
